import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormResponseComponent } from '../form-response/form-response.component';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { AsyncPipe, NgClass } from '@angular/common';
import { FormResponseService } from 'src/app/api/form-response.service';

@Component({
  selector: 'app-form-response-page',
  imports: [FormResponseComponent, NgClass, AsyncPipe],
  templateUrl: './form-response-page.component.html',
  styleUrl: './form-response-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormResponsePageComponent {

  id = signal(0)

  breakpointObserverSmall: Observable<BreakpointState> | undefined

  constructor(
    private route: ActivatedRoute,
      public breakpointObserver: BreakpointObserver,
      private formResponseService: FormResponseService
  )
  {}
  ngOnInit(): void {


    this.route.queryParamMap.subscribe(params => {
      const responseId = Number(params.get('responseId'))
      const formId = Number(params.get('formId'))


      if (responseId && !isNaN(responseId)) {
        this.id.set(responseId)
      }
      else {
         //FUTURE: Support anonymous forms
      }

    })

    // this.route.paramMap.subscribe(params => {
    //   const id = params.get('id')

    //   const idNumber = Number(id)

    //   if (!isNaN(idNumber)) {
    //     this.id.set(idNumber)
    //   }
    // })

    this.breakpointObserverSmall = this.breakpointObserver.observe([
      //  Breakpoints.XSmall,
      // Breakpoints.Small,
      '(max-width: 55rem)'
      // Breakpoints.Medium,
      // Breakpoints.Large,
      // Breakpoints.XLarge,
      // Breakpoints.WebLandscape,
      // Breakpoints.WebPortrait,
    ])
  }
}
